import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import {
  BlokkieButton,
  BlokkieIcon,
  blokkieTheme,
  BlokkieTypography,
} from '@tikkie/blokkie';

import { useClaimNavigationHeader } from '@/hooks/claim-navigation-header';

import tikkieLogo from '@/assets/tikkie-logo.svg';

export function ClaimHeader() {
  const navigate = useNavigate();

  const { t } = useTranslation();
  const { backButtonLink, currentStep, totalSteps } =
    useClaimNavigationHeader();

  const handleBackButton = () => {
    if (!backButtonLink) {
      return;
    }

    navigate(backButtonLink, { replace: true });
  };

  return (
    <header
      style={{
        position: 'relative',
        padding: blokkieTheme.spacing(2),
        zIndex: 10,
      }}
    >
      <div
        style={{
          display: 'flex',
          margin: '0 auto',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div>
          {backButtonLink && (
            <BlokkieButton
              variant="secondary"
              data-testid="back-button"
              onClick={handleBackButton}
              tabIndex={0}
              aria-label={t('claim.header.backButton')}
              style={{ minWidth: 0, margin: 0, padding: 0 }}
            >
              <BlokkieIcon tab-index={-1} variant="arrowLeft" color="white" />
            </BlokkieButton>
          )}
        </div>
        <div>
          <img
            src={tikkieLogo}
            tabIndex={0}
            data-testid="tikkie-logo"
            alt={t('imgs.tikkieLogo')}
            style={{ height: '2rem' }}
          />
        </div>
        <div>
          {(currentStep || totalSteps) && (
            <BlokkieTypography
              tabIndex={0}
              data-testid="step-indicator"
              variant="pm700"
              aria-label={t('claim.header.stepDescription', {
                currentStep,
                totalSteps,
              })}
            >
              <span>
                {currentStep}/{totalSteps}
              </span>
            </BlokkieTypography>
          )}
        </div>
      </div>
    </header>
  );
}
